import { PlanLengthType, PlanMembershipType, PricingProps } from "components/pricing/types";
import { setIsOneYearPremiumPlan, setMembership } from "redux/actions/pricingActions";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks";
import { useUpdateEffect } from "../utils/customHook/customHook";

export const useGetCurrentPricingPlan = () => {
  const dispatch = useAppDispatch();
  const { lang } = useAppSelector((state) => state.slidGlobal);
  const { planLength, membership, isOneYearPremiumPlan } = useAppSelector((state) => state.pricing);
  // monthly price is displayed on the plan option section only for users
  const [monthlyPrice, setMonthlyPrice] = useState("");
  //checkout price is number for stripe/payple payment
  const [checkoutPrice, setCheckoutPrice] = useState(0);

  const pricingOptions: PricingProps = {
    short: {
      standard: {
        checkout: lang === "ko" ? 16900 : 16.99,
        beforeSaleDisplay: "",
        afterSaleDisplay: lang === "ko" ? "16,900원" : "$16.99",
      },
      premium: {
        checkout: lang === "ko" ? 23900 : 23.99,
        beforeSaleDisplay: "",
        afterSaleDisplay: lang === "ko" ? "23,900원" : "$23.99",
      },
    },
    long: {
      standard: {
        beforeSaleCheckout: lang === "ko" ? "16,900원" : "$16.99",
        checkout: lang === "ko" ? 159900 : 159.99,
        beforeSaleDisplay: lang === "ko" ? "16,900원" : "$16.99",
        afterSaleDisplay: lang === "ko" ? "13,300원" : "$13.33",
      },
      premium: {
        beforeSaleCheckout: lang === "ko" ? "23,900원" : "$23.99",
        checkout: lang === "ko" ? 209900 : 209.99,
        beforeSaleDisplay: lang === "ko" ? "23,900원" : "$23.99",
        afterSaleDisplay: lang === "ko" ? "17,500원" : "$17.50",
      },
    },
  };

  useEffect(() => {
    const pricing = pricingOptions[planLength as PlanLengthType][membership as PlanMembershipType];
    // this effect is for updating monthly price and checkout price
    setMonthlyPrice(pricing.afterSaleDisplay);
    setCheckoutPrice(pricing.checkout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOneYearPremiumPlan, membership, planLength, lang]);

  const getCheckoutPrice = ({ planLength, membership }: { planLength: PlanLengthType; membership: PlanMembershipType }) => {
    return pricingOptions[planLength][membership].checkout;
  };

  useUpdateEffect(() => {
    dispatch(setMembership("premium"));
  }, []);

  useEffect(() => {
    if (planLength === "long" && membership === "premium") {
      dispatch(setIsOneYearPremiumPlan(true));
    } else {
      dispatch(setIsOneYearPremiumPlan(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planLength, membership]);

  return { monthlyPrice, checkoutPrice, pricingOptions, getCheckoutPrice };
};
